import React from 'react';
import * as Yup from 'yup';
import { WithChildrenProps } from '..';
import TranslateContext, { TranslateResources } from './TranslateContext';
import { translate } from './withTranslate';

interface TranslateProviderProps extends WithChildrenProps {
    language: string
}

interface TranslateProviderState {
    resources: TranslateResources
}

class TranslateProvider extends React.Component<TranslateProviderProps, TranslateProviderState> {

    constructor(props: TranslateProviderProps) {
        super(props);
        this.state = {
            resources: {}
        }
    }

    async getResource() {
        const { language } = this.props;
        var fileName = 'pt-br';
        if (language.startsWith('en')) {
            fileName = 'en';
        } else if (language.startsWith('es')) {
            fileName = 'es';
        }
        const response = await fetch(`locales/${fileName}.json?q=${Date.now()}`);
        const resources = await response.json();
        this.setState({ resources }, () => {
            this.setValidationMessages();
        });
    }

    setValidationMessages() {
        const t = (key: string, namespace: string) => translate(this.state.resources, namespace, key);
        Yup.setLocale({
            mixed: {
                default: t("default", 'form.validation.mixed'),
                required: t("required", 'form.validation.mixed'),
                notType: t("default", 'form.validation.mixed')
            },
            number: {
                //typeError: t("typeError", 'form.validation.number'),                
                integer: t("integer", 'form.validation.number'),
                min: t("min", 'form.validation.number'),
                max: t("max", 'form.validation.number'),
                positive: t("positive", 'form.validation.number'),
                //required: t("required", 'form.validation.number'),
            },
            string: {
                //typeError: t("typeError", 'form.validation.string'),
                min: t("min", 'form.validation.string'),
                max: t("max", 'form.validation.string'),
                //required: t("required", 'form.validation.string'),
                url: t("url", 'form.validation.string'),
                email: t("email", 'form.validation.string'),
            }
        });
    }

    componentDidMount() {
        this.getResource();
    }

    componentDidUpdate(prevProps: TranslateProviderProps) {
        if (prevProps.language !== this.props.language) {
            this.getResource();
        }
    }

    render() {
        const { children, language } = this.props;
        const { resources } = this.state;
        return (
            <TranslateContext.Provider value={{ language, resources }}>
                {children}
            </TranslateContext.Provider>
        );
    }
}

export default TranslateProvider;